import styled from 'styled-components';
import { Container } from 'components/domain/container';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { FdrStaticRequestButton } from 'components/domain/fdr-request-button';
import { FdrPdpMediaGallery } from 'components/domain/fdr-pdp-media-gallery';

export const FdrDisruptersContainer = styled(Container)(
  sx2CssThemeFn({
    '.product-disrupters': {
      position: 'absolute',
      bottom: 'auto',
      top: ['220px', '191px'],
      padding: ['0 16px', '0 20px'],
      '@media screen and (min-width: 1024px) and (max-width: 1096px)': {
        top: '212px',
      },
    },
  })
);

export const FdrPdpDescriptionWrapper = styled.div<{
  headerStickyWrapper: number;
}>(({ headerStickyWrapper }) =>
  sx2CssThemeFn({
    position: 'relative',
    padding: [0, '0 20px'],
    scrollMarginTop: `calc(${headerStickyWrapper}px + 30px)`,
    zIndex: 1,
    '&.is-hotel': {
      padding: 0,
    },
  })
);

export const FdrPdpDescriptionContainer = styled(Container)(
  ({ theme: { media, colors, space } }) => ({
    backgroundColor: colors.paperGrey,
    width: '100%',
    maxWidth: '1440px',
    left: 0,
    right: 0,
    marginTop: '-200px',
    padding: '40px',
    display: 'flex',
    gap: '80px',
    flexDirection: 'row',
    [media.tablet]: {
      flexDirection: 'column',
      gap: '60px',
    },
    [media.mobile]: {
      flexDirection: 'column',
      gap: space[6],
      marginTop: 0,
      padding: `${space[6]} ${space[3]}`,
    },
    [media.desktop]: {
      flexDirection: 'row',
      gap: '80px',
    },
    '@media screen and (min-width: 1025px) and (max-height: 795px)': {
      marginTop: '-48px',
    },
  })
);

export const FdrHotelDescriptionContainer = styled(Container)(
  sx2CssThemeFn({
    bg: 'greenLight',
    width: '100%',
    maxWidth: '100%',
    left: 0,
    right: 0,
    pt: ['35px', '90px'],
    pb: ['25px', '65px'],
    display: 'flex',
    flexDirection: 'row',
  })
);

export const FdrHotelDescriptionColumn = styled.div(
  sx2CssThemeFn({
    maxWidth: '818px',
    margin: '0 auto',
    fontSize: [3, '24px'],
    lineHeight: ['28px', '38px'],
  })
);

export const FdrPdpDescriptionLeadColumn = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    fontSize: [3, '24px'],
    lineHeight: ['28px', '38px'],
    letterSpacing: '0.5px',
  })
);

export const FdrPdpDescriptionRouteColumn = styled(Container)(
  ({ theme: { media, fontSizes } }) => ({
    width: '90%',
    fontSize: fontSizes[3],
    lineHeight: '160%',
    letterSpacing: '0.5px',
    padding: 0,
    [media.tablet]: {
      flexDirection: 'column',
      width: '100%',
    },
    [media.mobile]: {
      width: '100%',
      fontSize: fontSizes[1],
    },
    [media.desktop]: {
      width: '90%',
      margin: 0,
    },
  })
);

export const FdrPdpLeadText = styled.div(
  sx2CssThemeFn({
    mb: 6,
    a: {
      textDecoration: 'underline',
      '&:hover': {
        color: 'redHover',
      },
    },
    '&.is-hotel': {
      mb: 3,
    },
  })
);

export const FdrFeatureBlock = styled(FdrPdpLeadText)(
  sx2CssThemeFn({
    pb: 4,
    mb: '40px',
    borderBottom: `1px solid`,
    borderColor: 'borderColor',
    ':last-of-type': {
      mb: '10px',
    },
    '.feature-name': {
      display: 'block',
      fontSize: '15px',
      textTransform: 'uppercase',
      color: 'redBurgundy',
    },
  })
);

export const FdrPdpDescriptionRequestButton = styled(FdrStaticRequestButton)({
  '&.static-request-button-wrapper': {
    flexDirection: 'inherit',
    marginLeft: 0,
    maxWidth: '100%',
  },
});

export const FdrRequestButtonContainer = styled.div<{ mobile: boolean }>(
  ({ theme: { space }, mobile }) => ({
    marginTop: mobile ? space[6] : '40px',
  })
);

export const FdrIndividualOfferButtonRequestButton = styled(
  FdrStaticRequestButton
)({
  '&.static-request-button-wrapper': {
    '.request-button': {
      margin: ' 0 auto',
      padding: ' 0 30px',
      height: '42px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '.request-button-caption': {
        '& br': {
          display: 'inline',
          content: "' '",
          padding: '0 3px',
        },
      },
    },
  },
});

const ADDITIONAL_GALLERY_ASPECT_RATIO = '86%';

export const FdrAdditionalGalleryWrapper = styled.div(
  sx2CssThemeFn({
    position: 'relative',
    width: '100%',
    mb: ['40px', '20px'],
    '.preview-media-gallery': {
      '&:after': {
        pb: ADDITIONAL_GALLERY_ASPECT_RATIO,
      },
      '.open-preview': {
        bottom: 'auto',
        top: '10px',
        right: '10px',
        '&:hover, &:focus, &:active': {
          backgroundColor: 'transparent',
          color: 'transparent',
        },
        '.preview-icon': {
          width: '30px',
          height: '30px',
        },
      },
    },
  })
);

export const FdrHotelMediaGallery = styled(FdrPdpMediaGallery)(
  sx2CssThemeFn({
    mt: ['30px', '70px'],
    mb: ['30px', '40px'],
    '> div': {
      maxHeight: '640px',
    },
    '.open-preview': {
      mr: [3, '40px'],
      mb: 3,
      '.icon': {
        fill: 'transparent',
        width: '32px',
        height: '32px',
      },
      '&:hover, &:focus': {
        backgroundColor: 'transparent',
      },
    },
  })
);
